var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3253 10.2285L14.7395 11.6427L11.3821 15.0001L14.7395 18.3575L13.3253 19.7717L8.55363 15.0001L13.3253 10.2285Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3099 5.80757C15.4903 5.20083 13.3462 4.92817 11.2173 5.01615C9.09113 5.10401 7.04722 5.54893 5.42032 6.31148C3.82382 7.05977 2.55321 8.15571 2.13822 9.55665C1.69558 11.0509 2.34001 12.4572 3.55102 13.5059C3.96851 13.8675 4.60005 13.8221 4.96161 13.4047C5.32316 12.9872 5.27782 12.3556 4.86033 11.9941C4.04035 11.2839 3.90333 10.6396 4.05585 10.1247C4.236 9.51657 4.90212 8.76315 6.26912 8.12242C7.60572 7.49595 9.37782 7.09387 11.2999 7.01444C13.2192 6.93512 15.1173 7.18471 16.6772 7.70486C18.2631 8.2337 19.2767 8.96554 19.7251 9.66082C19.9385 9.9917 20.011 10.2911 19.9985 10.5584C19.9859 10.828 19.8833 11.1381 19.6271 11.4798C19.094 12.1907 17.9884 12.9061 16.3506 13.3986C14.7363 13.8841 12.8136 14.0885 10.9055 13.9646C10.3544 13.9288 9.87857 14.3466 9.84278 14.8977C9.80698 15.4488 10.2247 15.9246 10.7759 15.9604C12.8959 16.0981 15.0599 15.8752 16.9265 15.3139C18.7696 14.7596 20.3345 13.8703 21.2273 12.6795C21.684 12.0703 21.9622 11.3832 21.9964 10.6517C22.0306 9.9179 21.8158 9.21235 21.4058 8.57675C20.6075 7.33907 19.1034 6.40563 17.3099 5.80757Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.aa5a278b4f879f4b0ec36950070f0c29.svg";
export { ForwardRef as ReactComponent };